import React, { Component, Fragment } from 'react'
import './styles/carousel.scss'

class Carousel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scrollState: 'left',
        }
        this.scrollRef = React.createRef()
    }

    componentDidMount() {
        if (this.scrollRef.current) {
            this.scrollRef.current.addEventListener('scroll', this.handleScroll)
            this.handleScroll()
        }
    }

    componentWillUnmount() {
        if (this.scrollRef.current) {
            this.scrollRef.current.removeEventListener('scroll', this.handleScroll)
        }
    }

      handleScroll = () => {
          this.getScrollPosition()
      }

    getScrollPosition = () => {
        if (this.scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = this.scrollRef.current
            const isScrollbarNecessary = scrollWidth > clientWidth

            if (!isScrollbarNecessary) {
                this.setState({ scrollState: 'none' })
            } else if (scrollLeft === 0) {
                this.setState({ scrollState: 'left' })
            } else if (scrollLeft + clientWidth >= scrollWidth) {
                this.setState({ scrollState: 'right' })
            } else {
                this.setState({ scrollState: 'mid' })
            }
        }
    }

    scrollToRight = () => {
        const { scrollButtonWidth } = this.props
        if (this.scrollRef.current) {
            const { scrollWidth, scrollLeft } = this.scrollRef.current
            const newLeftPosition = scrollLeft + (scrollButtonWidth || 450)
            this.scrollRef.current.scrollTo({
                left: newLeftPosition > scrollWidth ? scrollWidth : newLeftPosition,
                behavior: 'smooth',
            })
        }
    }

      scrollToLeft = () => {
          const { scrollButtonWidth } = this.props
          if (this.scrollRef.current) {
              const { scrollLeft } = this.scrollRef.current
              const newLeftPosition = scrollLeft - (scrollButtonWidth || 450)
              this.scrollRef.current.scrollTo({
                  left: newLeftPosition < 0 ? 0 : newLeftPosition,
                  behavior: 'smooth',
              })
          }
      }

      render() {
          const {
              items, cssClass, style,
          } = this.props
          const { scrollState } = this.state

          return (
              <div className={`carousel ${cssClass || ''}`} style={style}>
                  {scrollState !== 'none'
                      ? (
                          <Fragment>
                              <div className={`scrollButton left ${scrollState === 'left' ? 'hide' : ''}`} onClick={this.scrollToLeft}><i className="fa-solid fa-chevron-left" /></div>
                              <div className={`scrollButton right ${scrollState === 'right' ? 'hide' : ''}`} onClick={this.scrollToRight}><i className="fa-solid fa-chevron-right" /></div>
                          </Fragment>
                      )
                      : null}
                  <div className="carouselItems" ref={this.scrollRef}>
                      {items}
                  </div>
              </div>
          )
      }
}

export default Carousel
